// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__1IYPj","title":"AfterFrontImage_title__3LlNe"};